import { useContext } from 'react';

import { InsightsTimeframeContext } from './context';

export const useInsightsTimeframe = () => {
  const value = useContext(InsightsTimeframeContext);

  if (!value) {
    throw new Error(
      'useInsightsTimeframe must be used within InsightsTimeframeProvider',
    );
  }

  return value;
};

export const useInsightsTimeframeOptional = () =>
  useContext(InsightsTimeframeContext);
